var styles = [".clr-select-wrapper[_ngcontent-%COMP%]   select[_ngcontent-%COMP%], form[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:not(button){font-size:.7rem}"];
export { styles as styles };
